export default data => ({
  type: 'SEARCH_BAR_UI_UPDATE',
  payload: data,
});
